export const stepOneData = [
  {
    stepOneHeading: "1. Understand Debt Consolidation",
    paraOne:
      "Debt consolidation involves combining multiple debts into a single loan, ideally with a lower interest rate and more favorable terms. This approach simplifies repayments and can reduce the total interest paid over time.",

    tip: " Consolidating debts can also improve your credit score by ensuring timely repayments.",
  },
];

export const stepTwoData = [
  {
    stepTwoHeading: "2. Evaluate Your Financial Situation",
    paraOne: "Before proceeding, assess your current financial health:",

    // paraThree after "How much do you need to borrow for debt consolidation?"

    financialHealthList: [
      {
        head: "List All Debts: ",
        info: "Consolidation rolls multiple debts into one new one.",
      },
      {
        head: "Calculate Total Debt: ",
        info: "Sum up all outstanding balances.",
      },
      {
        head: "Assess Monthly Payments: ",
        info: "Determine the total amount paid monthly towards debts.",
      },
      {
        head: "Review Interest Rates: ",
        info: "Note the interest rates for each debt.",
      },
    ],
    tip: "Understanding your financial standing helps in making informed decisions about debt consolidation.",
  },
];

export const stepThreeData = [
  {
    stepThreeHeading: "3. Identify Debts Eligible for Consolidation",
    paraOne:
      "Not all debts are suitable for consolidation. Typically, unsecured debts like credit card balances, personal loans, and education loans are eligible. Secured debts, such as home loans, may not be ideal candidates for consolidation.",
  },
];

export const stepFourData = [
  {
    stepFourHeading: "4. Use Minemi’s Debt Consolidation Calculator",
    paraOne:
      "Input your existing debts into Minemi’s Debt Consolidation Calculator to estimate:",

    debtCalculatorList: [
      {
        head: "New EMI Amount: ",
        info: "The expected monthly payment after consolidation.",
      },
      {
        head: "Total Interest Payable: ",
        info: "The cumulative interest over the loan tenure.",
      },
      {
        head: "Total Repayment Amount: ",
        info: "The sum of principal and interest to be repaid.",
      },
    ],

    debtTable: {
      headings: [
        {
          head: "Loan Type",
        },
        {
          head: "Amount (₹)",
        },
        {
          head: "Interest Rate (%)",
        },
        {
          head: "Tenure (Years)",
        },
        {
          head: "EMI (₹)",
        },
        {
          head: "Total Repayment (₹)",
        },
      ],
      row: [
        {
          loanType: "Credit Card",
          amount: "₹1,00,000",
          interest: "18%",
          tenure: "2",
          emi: "₹5,016",
          repayment: "₹1,20,384",
        },
        {
          loanType: "Personal Loan",
          amount: "₹2,00,000",
          interest: "15%",
          tenure: "3",
          emi: "₹6,933",
          repayment: "₹2,49,588",
        },
      ],
    },

    consolidationTable: {
      headings: [
        {
          head: "Amount (₹)",
        },
        {
          head: "Interest Rate (%)",
        },
        {
          head: "Tenure (Years)",
        },
        {
          head: "EMI (₹)",
        },
        {
          head: "Total Repayment (₹)",
        },
      ],
      row: [
        {
          amount: "₹3,00,000",
          interest: "12%",
          tenure: "3",
          emi: "₹9,967",
          repayment: "₹3,58,812",
        },
      ],
    },
    tip: " A consolidated loan with a lower interest rate can significantly reduce your EMI and total repayment amount.",
  },
];

export const stepFiveData = [
  {
    stepFiveHeading: "5. Compare Consolidation Loan Offers",
    paraOne:
      "Research various lenders to find the best consolidation loan terms:",

    list: [
      {
        head: "Interest Rates: ",
        info: "Lower rates reduce overall repayment.",
      },
      {
        head: "Loan Tenure: ",
        info: "Choose a tenure that balances EMI affordability and total interest paid.",
      },
      {
        head: "Processing Fees: ",
        info: "Be aware of any additional charges that may apply.",
      },
    ],
    tip: "Use Minemi to compare personalized loan offers from multiple lenders.",
  },
];

export const stepSixData = [
  {
    stepSixHeading: "6. Apply for a Debt Consolidation Loan",
    paraOne: "Once you’ve selected a suitable offer:",

    list: [
      {
        head: "Gather Necessary Documents: ",
        info: " Proof of income, identification, and existing loan statements.",
      },
      {
        head: "Submit Application: ",
        info: "Apply through Minemi’s platform for a seamless experience.",
      },
      {
        head: "Await Approval: ",
        info: "Lenders will assess your application based on creditworthiness.",
      },
    ],
  },
];

export const stepSevenData = [
  {
    stepSevenHeading: "7. Close Existing Debts",
    paraOne: "Upon receiving the consolidation loan:",

    list: [
      {
        head: "Pay Off Existing Debts: ",
        info: " Use the funds to clear all debts included in the consolidation.",
      },
      {
        head: "Obtain Closure Letters:",
        info: "Ensure you receive official confirmation of debt closure from previous lenders.",
      },
    ],
  },
];

export const stepsEightData = [
  {
    stepsEightHeading: "8. Manage Your New Loan Effectively",
    paraOne: "Adopt disciplined financial habits:",

    list: [
      {
        head: "Timely Payments: ",
        info: "Set up automatic payments to avoid missing EMIs.",
      },
      {
        head: "Budgeting:",
        info: "Adjust your budget to accommodate the new EMI.",
      },
      {
        head: "Avoid New Debts:",
        info: "Refrain from accumulating additional debts during the repayment period.",
      },
    ],
  },
];
export const stepsNineData = [
  {
    stepsNineHeading: "9. Monitor Your Credit Score",
    paraOne:
      "Regularly check your credit score to track improvements resulting from timely repayments. A higher credit score can open doors to better financial opportunities in the future.",

    tip: "Use Minemi’s platform to monitor your credit score and receive personalized financial advice.",
  },
];
